import React from 'react';
import PP from '../../Assets/Images/profilepic.png';
import Address from '../../Assets/Print/address.png';
import Phone from '../../Assets/Print/phone.png';
import Mail from '../../Assets/Print/email.png';
import Github from '../../Assets/Print/github.png';
import Linkedin from '../../Assets/Print/linkedin.png';
import Plink from '../../Assets/Print/link.png';

import { Landingdata } from '../../Data/Landingdata';
import { Langdata } from '../../Data/Langdata';
import { Skillsdata } from '../../Data/Skillsdata';
import { expdata } from '../../Data/Experiencedata';
import { achdata } from '../../Data/Achievementdata';
import { projects } from '../../Data/projectsdata';
import { research } from '../../Data/Researchdata';
import { edudata } from '../../Data/Educationdata';

import { Link } from 'react-router-dom';

const Print = () => {
  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800;900&display=swap');
        
        * {
          margin: 0;
          padding: 0;
          box-sizing: border-box;
        }

        body {
          font-family: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;
          -webkit-font-smoothing: antialiased;
          -moz-osx-font-smoothing: grayscale;
        }

        .resume-container {
          min-height: 100vh;
          background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
          padding: 3rem 1.5rem;
          font-family: 'Inter', sans-serif;
        }

        .back-button {
          position: fixed;
          top: 1.5rem;
          left: 1.5rem;
          background: rgba(255, 255, 255, 0.95);
          color: #1e293b;
          padding: 0.875rem 1.75rem;
          border: none;
          border-radius: 12px;
          cursor: pointer;
          font-weight: 700;
          text-decoration: none;
          display: inline-flex;
          align-items: center;
          gap: 0.5rem;
          box-shadow: 0 8px 24px rgba(0,0,0,0.15);
          transition: all 0.3s;
          z-index: 1000;
          font-size: 0.95rem;
          backdrop-filter: blur(10px);
        }

        .back-button:hover {
          background: white;
          transform: translateY(-3px);
          box-shadow: 0 12px 32px rgba(0,0,0,0.2);
        }

        .resume-paper {
          max-width: 900px;
          margin: 0 auto;
          background: white;
          box-shadow: 0 25px 80px rgba(0,0,0,0.2);
          border-radius: 16px;
          overflow: hidden;
        }

        /* Header Section */
        .resume-header {
          background: linear-gradient(135deg, #1e293b 0%, #334155 100%);
          color: white;
          padding: 3rem 3rem 2rem;
          position: relative;
          overflow: hidden;
        }

        .header-decoration {
          position: absolute;
          top: -50px;
          right: -50px;
          width: 200px;
          height: 200px;
          background: radial-gradient(circle, rgba(251, 191, 36, 0.2) 0%, transparent 70%);
          border-radius: 50%;
        }

        .header-layout {
          display: flex;
          gap: 2rem;
          align-items: center;
          position: relative;
          z-index: 1;
        }

        .profile-photo {
          width: 130px;
          height: 130px;
          border-radius: 20px;
          overflow: hidden;
          border: 4px solid rgba(251, 191, 36, 0.3);
          flex-shrink: 0;
          box-shadow: 0 12px 32px rgba(0,0,0,0.3);
        }

        .profile-photo img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }

        .header-text {
          flex: 1;
        }

        .name {
          font-size: 2.75rem;
          font-weight: 800;
          margin-bottom: 0.5rem;
          letter-spacing: -1px;
          line-height: 1.1;
        }

        .tagline {
          font-size: 1.35rem;
          color: #fbbf24;
          font-weight: 600;
          margin-bottom: 1.25rem;
          letter-spacing: 0.5px;
        }

        .contact-info {
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: 0.75rem;
          font-size: 0.8rem;
        }

        .contact-link {
          display: flex;
          align-items: center;
          gap: 0.5rem;
          color: #e2e8f0;
          text-decoration: none;
          transition: color 0.2s;
        }

        .contact-link:hover {
          color: #fbbf24;
        }

        .contact-icon {
          width: 16px;
          height: 16px;
          opacity: 0.8;
          filter: brightness(0) invert(1);
        }

        /* Main Layout */
        .resume-body {
          display: grid;
          grid-template-columns: 320px 1fr;
        }

        /* Sidebar */
        .sidebar {
          background: linear-gradient(180deg, #f8fafc 0%, #f1f5f9 100%);
          padding: 2.5rem 2rem;
          border-right: 1px solid #e2e8f0;
        }

        .sidebar-section {
          margin-bottom: 2.5rem;
        }

        .sidebar-title {
          font-size: 0.9rem;
          font-weight: 800;
          color: #1e293b;
          text-transform: uppercase;
          letter-spacing: 1.5px;
          margin-bottom: 1.25rem;
          display: flex;
          align-items: center;
          gap: 0.5rem;
        }

        .sidebar-title::before {
          content: '';
          width: 4px;
          height: 16px;
          background: linear-gradient(180deg, #f59e0b, #ef4444);
          border-radius: 2px;
        }

        /* About */
        .about-text {
          font-size: 0.8rem;
          color: #475569;
          line-height: 1.7;
          text-align: justify;
        }

        /* Skills Cards */
        .skills-grid {
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          gap: 0.65rem;
        }

        .skill-card {
          background: white;
          padding: 0.65rem 0.85rem;
          border-radius: 10px;
          font-size: 0.75rem;
          font-weight: 600;
          color: #334155;
          text-align: center;
          box-shadow: 0 2px 8px rgba(0,0,0,0.08);
          border: 1px solid #e2e8f0;
          transition: all 0.2s;
        }

        .skill-card:hover {
          transform: translateY(-2px);
          box-shadow: 0 4px 12px rgba(0,0,0,0.12);
          border-color: #fbbf24;
        }

        /* Languages */
        .language-item {
          margin-bottom: 1.25rem;
        }

        .language-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 0.5rem;
        }

        .language-name {
          font-size: 0.8rem;
          font-weight: 700;
          color: #1e293b;
        }

        .language-percent {
          font-size: 0.75rem;
          font-weight: 700;
          color: #f59e0b;
        }

        .progress-bar {
          width: 100%;
          height: 8px;
          background: #e2e8f0;
          border-radius: 4px;
          overflow: hidden;
          box-shadow: inset 0 1px 3px rgba(0,0,0,0.1);
        }

        .progress-fill {
          height: 100%;
          background: linear-gradient(90deg, #f59e0b, #ef4444);
          border-radius: 4px;
          transition: width 0.3s;
        }

        /* Education */
        .education-card {
          background: white;
          padding: 1rem;
          border-radius: 10px;
          margin-bottom: 1rem;
          border-left: 3px solid #f59e0b;
          box-shadow: 0 2px 8px rgba(0,0,0,0.08);
        }

        .edu-date {
          color: #f59e0b;
          font-weight: 700;
          font-size: 0.75rem;
          margin-bottom: 0.5rem;
        }

        .edu-degree {
          font-weight: 700;
          color: #1e293b;
          font-size: 0.85rem;
          margin-bottom: 0.25rem;
          line-height: 1.3;
        }

        .edu-institute {
          color: #475569;
          font-size: 0.75rem;
          font-weight: 600;
          margin-bottom: 0.25rem;
        }

        .edu-location {
          color: #64748b;
          font-size: 0.7rem;
        }

        /* Content Section */
        .content {
          padding: 2.5rem 2rem;
        }

        .content-section {
          margin-bottom: 3rem;
        }

        .section-title {
          font-size: 1.25rem;
          font-weight: 800;
          color: #1e293b;
          margin-bottom: 1.5rem;
          display: flex;
          align-items: center;
          gap: 0.75rem;
          padding-bottom: 0.75rem;
          border-bottom: 3px solid #e2e8f0;
        }

        .section-icon {
          font-size: 1.5rem;
        }

        /* Timeline Items */
        .timeline {
          position: relative;
        }

        .timeline-item {
          position: relative;
          padding-left: 2rem;
          padding-bottom: 2rem;
          border-left: 2px solid #e2e8f0;
        }

        .timeline-item:last-child {
          padding-bottom: 0;
          border-left: none;
        }

        .timeline-dot {
          position: absolute;
          width: 14px;
          height: 14px;
          background: linear-gradient(135deg, #f59e0b, #ef4444);
          border-radius: 50%;
          left: -8px;
          top: 6px;
          box-shadow: 0 0 0 4px white, 0 0 0 6px #e2e8f0;
        }

        .timeline-header {
          display: flex;
          justify-content: space-between;
          align-items: flex-start;
          margin-bottom: 0.5rem;
          gap: 1rem;
        }

        .timeline-title {
          font-weight: 800;
          color: #1e293b;
          font-size: 0.95rem;
          line-height: 1.3;
        }

        .timeline-date {
          font-size: 0.75rem;
          color: white;
          background: linear-gradient(135deg, #f59e0b, #ef4444);
          padding: 0.35rem 0.85rem;
          border-radius: 20px;
          font-weight: 700;
          white-space: nowrap;
          box-shadow: 0 2px 8px rgba(245, 158, 11, 0.3);
        }

        .timeline-company {
          font-size: 0.85rem;
          color: #475569;
          font-weight: 700;
          margin-bottom: 0.75rem;
        }

        .timeline-description {
          font-size: 0.8rem;
          color: #64748b;
          line-height: 1.7;
          margin-bottom: 0.75rem;
          text-align: justify;
        }

        .timeline-tags {
          display: flex;
          flex-wrap: wrap;
          gap: 0.5rem;
        }

        .tag {
          background: linear-gradient(135deg, #f1f5f9, #e2e8f0);
          color: #334155;
          padding: 0.35rem 0.75rem;
          border-radius: 6px;
          font-size: 0.7rem;
          font-weight: 600;
          border: 1px solid #cbd5e1;
        }

        /* Research-specific styles */
        .research-meta {
          font-size: 0.75rem;
          color: #64748b;
          margin-bottom: 0.5rem;
          line-height: 1.6;
        }

        .research-authors {
          font-weight: 600;
          color: #475569;
        }

        .research-venue {
          font-style: italic;
          color: #64748b;
          margin-top: 0.25rem;
        }

        .research-tags {
          display: flex;
          flex-wrap: wrap;
          gap: 0.5rem;
          margin-top: 0.75rem;
        }

        .research-tag {
          background: linear-gradient(135deg, #06b6d4, #8b5cf6);
          color: white;
          padding: 0.3rem 0.7rem;
          border-radius: 6px;
          font-size: 0.65rem;
          font-weight: 700;
          text-transform: uppercase;
          letter-spacing: 0.5px;
          border: none;
        }

        .project-link {
          font-size: 0.75rem;
          color: #f59e0b;
          text-decoration: none;
          font-weight: 600;
          display: inline-block;
          margin-top: 0.5rem;
          transition: color 0.2s;
        }

        .project-link:hover {
          color: #ef4444;
          text-decoration: underline;
        }

        /* Print Styles */
        @media print {
          @page { 
            size: A4;
            margin: 10mm 10mm 10mm 10mm;
          }
            @media print {
  /* Target only Professional Experience section */
  
  .content-section:nth-child(1) .timeline-item {
    padding-bottom: 1.7rem !important;
  }
  
  .content-section:nth-child(1) .timeline-description {
    line-height: 2 !important;
    margin-bottom: 0.7rem !important;
  }
}
   /* Print Styles */
@media print {
  @page { 
    size: A4;
    margin: 10mm 10mm 15mm 10mm; /* Extra bottom margin for footer */
  }
  
  /* ADD THIS CODE HERE - Page numbering */
  @page {
    @bottom-right {
      content: "Page " counter(page) " of " counter(pages);
      font-size: 0.7rem;
      color: #64748b;
      font-weight: 500;
    }
  }
  
  /* Rest of your existing print styles continue below... */
  * {
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
    color-adjust: exact !important;
  }       
          * {
            -webkit-print-color-adjust: exact !important;
            print-color-adjust: exact !important;
            color-adjust: exact !important;
          }
          
          body {
            margin: 0;
            background: white !important;
          }

          .resume-container {
            background: white !important;
            padding: 0 !important;
            min-height: auto;
          }

          .back-button {
            display: none !important;
          }

          .resume-paper {
            box-shadow: none !important;
            border-radius: 0 !important;
            max-width: 100%;
            margin: 0 !important;
          }

          .resume-header {
            padding: 1.25rem 1.5rem 1rem !important;
            page-break-after: avoid;
            break-after: avoid;
          }

          .header-layout {
            gap: 1.25rem;
          }

          .profile-photo {
            width: 90px;
            height: 90px;
          }

          .name {
            font-size: 1.85rem !important;
          }

          .tagline {
            font-size: 0.95rem !important;
            margin-bottom: 0.75rem !important;
          }

          .contact-info {
            grid-template-columns: repeat(3, 1fr);
            gap: 0.4rem;
            font-size: 0.65rem;
          }

          .contact-icon {
            width: 12px;
            height: 12px;
          }

          .resume-body {
            grid-template-columns: 280px 1fr;
          }

          .sidebar {
            padding: 1.25rem 1rem !important;
          }

          .content {
            padding: 1.25rem 1rem !important;
          }

          .sidebar-section {
            margin-bottom: 1.5rem !important;
            page-break-inside: avoid;
            break-inside: avoid;
          }

          .sidebar-title {
            font-size: 0.75rem !important;
            margin-bottom: 0.75rem !important;
          }

          .about-text {
            font-size: 0.7rem !important;
            line-height: 1.5;
          }

          .skills-grid {
            gap: 0.4rem;
          }

          .skill-card {
            padding: 0.45rem 0.6rem;
            font-size: 0.65rem;
          }

          .language-item {
            margin-bottom: 0.85rem !important;
          }

          .language-name {
            font-size: 0.7rem !important;
          }

          .language-percent {
            font-size: 0.65rem !important;
          }

          .progress-bar {
            height: 6px;
          }

          .education-card {
            padding: 0.75rem;
            margin-bottom: 0.75rem;
            page-break-inside: avoid;
            break-inside: avoid;
          }

          .edu-date {
            font-size: 0.65rem;
          }

          .edu-degree {
            font-size: 0.75rem;
          }

          .edu-institute {
            font-size: 0.65rem;
          }

          .edu-location {
            font-size: 0.6rem;
          }

          .content-section {
            margin-bottom: 1.5rem !important;
            page-break-inside: auto;
            break-inside: auto;
          }
          
          .section-title {
            font-size: 1rem !important;
            margin-bottom: 0.85rem !important;
            padding-bottom: 0.5rem !important;
            page-break-after: avoid;
            break-after: avoid;
          }

          .section-icon {
            font-size: 1.1rem;
          }

          .timeline-item {
            padding-bottom: 1rem !important;
            page-break-inside: avoid;
            break-inside: avoid;
          }

          .timeline-dot {
            width: 10px;
            height: 10px;
            left: -6px;
          }

          .timeline-header {
            margin-bottom: 0.35rem;
          }

          .timeline-title {
            font-size: 0.8rem !important;
          }

          .timeline-date {
            font-size: 0.65rem !important;
            padding: 0.25rem 0.6rem;
          }

          .timeline-company {
            font-size: 0.75rem !important;
            margin-bottom: 0.35rem !important;
          }

          .timeline-description {
            font-size: 0.7rem !important;
            line-height: 1.5;
            margin-bottom: 0.5rem !important;
          }

          .timeline-tags,
          .research-tags {
            gap: 0.35rem;
            margin-top: 0.5rem;
          }

          .tag {
            padding: 0.25rem 0.5rem;
            font-size: 0.6rem;
          }

          .research-tag {
            padding: 0.25rem 0.5rem;
            font-size: 0.55rem;
          }

          .research-meta {
            font-size: 0.65rem !important;
            margin-bottom: 0.35rem;
          }

          .research-venue {
            font-size: 0.65rem !important;
          }

          .project-link {
            font-size: 0.65rem !important;
            margin-top: 0.35rem;
          }

          /* Force page breaks between major sections when needed */
          .content-section:nth-child(2) {
            page-break-before: auto;
            break-before: auto;
          }

          /* Prevent orphaned headers */
          h2, h3, .section-title, .sidebar-title {
            page-break-after: avoid;
            break-after: avoid;
          }

          /* Keep timeline items together */
          .timeline-item {
            page-break-inside: avoid;
            break-inside: avoid;
            orphans: 3;
            widows: 3;
          }
        }

        /* Responsive */
        @media screen and (max-width: 768px) {
          .resume-container {
            padding: 1.5rem 1rem;
          }

          .resume-body {
            grid-template-columns: 1fr;
          }

          .sidebar {
            border-right: none;
            border-bottom: 1px solid #e2e8f0;
          }

          .header-layout {
            flex-direction: column;
            text-align: center;
          }

          .contact-info {
            grid-template-columns: 1fr;
          }

          .name {
            font-size: 2rem;
          }

          .tagline {
            font-size: 1.1rem;
          }
        }
      `}</style>

      <div className="resume-container">
        <Link to="/" className="back-button">
          <span>←</span>
          <span>Back to Portfolio</span>
        </Link>

        <div className="resume-paper">
          {/* Header */}
          <div className="resume-header">
            <div className="header-decoration"></div>
            <div className="header-layout">
              <div className="profile-photo">
                <img src={PP} alt="Profile" />
              </div>
              <div className="header-text">
                <h1 className="name">{Landingdata.name}</h1>
                <p className="tagline">{Landingdata.about}</p>
                <div className="contact-info">
                  <a href={`mailto:${Landingdata.mail}`} className="contact-link">
                    <img src={Mail} alt="" className="contact-icon" />
                    <span>{Landingdata.mail}</span>
                  </a>
                  <a href={`tel:${Landingdata.phone}`} className="contact-link">
                    <img src={Phone} alt="" className="contact-icon" />
                    <span>{Landingdata.phone}</span>
                  </a>
                  <span className="contact-link">
                    <img src={Address} alt="" className="contact-icon" />
                    <span>{Landingdata.address}</span>
                  </span>
                  <a href={Landingdata.Portfoliolink} className="contact-link" target="_blank" rel="noopener noreferrer">
                    <img src={Plink} alt="" className="contact-icon" />
                    <span>Portfolio</span>
                  </a>
                  <a href={Landingdata.linkedin} className="contact-link" target="_blank" rel="noopener noreferrer">
                    <img src={Linkedin} alt="" className="contact-icon" />
                    <span>LinkedIn</span>
                  </a>
                  <a href={Landingdata.github} className="contact-link" target="_blank" rel="noopener noreferrer">
                    <img src={Github} alt="" className="contact-icon" />
                    <span>GitHub</span>
                  </a>
                </div>
              </div>
            </div>
          </div>

          {/* Body */}
          <div className="resume-body">
            {/* Sidebar */}
            <div className="sidebar">
              {/* About */}
              <div className="sidebar-section">
                <h2 className="sidebar-title">About Me</h2>
                <p className="about-text">{Landingdata.info}</p>
              </div>

              {/* Skills */}
              <div className="sidebar-section">
                <h2 className="sidebar-title">Core Skills</h2>
                <div className="skills-grid">
                  {Skillsdata.map((skill, index) => (
                    <div key={index} className="skill-card">{skill}</div>
                  ))}
                </div>
              </div>

              {/* Languages */}
              <div className="sidebar-section">
                <h2 className="sidebar-title">Languages</h2>
                {Langdata.map((lang) => (
                  <div key={lang.id} className="language-item">
                    <div className="language-header">
                      <span className="language-name">{lang.language}</span>
                      <span className="language-percent">{lang.percentage}%</span>
                    </div>
                    <div className="progress-bar">
                      <div className="progress-fill" style={{ width: `${lang.percentage}%` }}></div>
                    </div>
                  </div>
                ))}
              </div>

              {/* Education */}
              <div className="sidebar-section">
                <h2 className="sidebar-title">Education</h2>
                {edudata.map((edu) => (
                  <div key={edu.id} className="education-card">
                    <div className="edu-date">{edu.date}</div>
                    <h3 className="edu-degree">{edu.degree}</h3>
                    <p className="edu-institute">{edu.insitute}</p>
                    <p className="edu-location">{edu.address}</p>
                  </div>
                ))}
              </div>
            </div>

            {/* Content */}
            <div className="content">
              {/* Experience */}
              <div className="content-section">
                <h2 className="section-title">
                  <span className="section-icon">💼</span>
                  <span>Professional Experience</span>
                </h2>
                <div className="timeline">
                  {expdata.map((exp) => (
                    <div key={exp.id} className="timeline-item">
                      <div className="timeline-dot"></div>
                      <div className="timeline-header">
                        <h3 className="timeline-title">{exp.position}</h3>
                        <span className="timeline-date">{exp.date}</span>
                      </div>
                      <p className="timeline-company">@ {exp.company}</p>
                      <p className="timeline-description">{exp.about}</p>
                      <div className="timeline-tags">
                        {exp.skills.split(',').map((skill, idx) => (
                          <span key={idx} className="tag">{skill.trim()}</span>
                        ))}
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              {/* Research & Publications */}
              {research && research.length > 0 && (
                <div className="content-section">
                  <h2 className="section-title">
                    <span className="section-icon">📚</span>
                    <span>Research & Publications</span>
                  </h2>
                  <div className="timeline">
                    {research.map((item) => (
                      <div key={item.id} className="timeline-item">
                        <div className="timeline-dot"></div>
                        <div className="timeline-header">
                          <h3 className="timeline-title">{item.title}</h3>
                          {item.year && <span className="timeline-date">{item.year}</span>}
                        </div>
                        
                        {item.authors && (
                          <div className="research-meta">
                            <span className="research-authors">Authors: {item.authors}</span>
                          </div>
                        )}
                        
                        {item.venue && (
                          <p className="research-venue">{item.venue}</p>
                        )}
                        
                        <p className="timeline-description">{item.description}</p>
                        
                        {item.tags && item.tags.length > 0 && (
                          <div className="research-tags">
                            {item.tags.map((tag, idx) => (
                              <span key={idx} className="research-tag">{tag}</span>
                            ))}
                          </div>
                        )}
                        
                        {(item.doi || item.paper || item.linklive) && (
                          <div style={{ marginTop: '0.5rem' }}>
                            {item.doi && (
                              <a href={item.doi} className="project-link" target="_blank" rel="noopener noreferrer">
                                View DOI →
                              </a>
                            )}
                            {item.paper && (
                              <a href={item.paper} className="project-link" target="_blank" rel="noopener noreferrer" style={{ marginLeft: '1rem' }}>
                                Read Paper →
                              </a>
                            )}
                            {item.linklive && (
                              <a href={item.linklive} className="project-link" target="_blank" rel="noopener noreferrer" style={{ marginLeft: '1rem' }}>
                                View Publication →
                              </a>
                            )}
                          </div>
                        )}
                      </div>
                    ))}
                  </div>
                </div>
              )}

              {/* Projects */}
              <div className="content-section">
                <h2 className="section-title">
                  <span className="section-icon">💻</span>
                  <span>Projects</span>
                </h2>
                <div className="timeline">
                  {projects.map((project) => (
                    <div key={project.id} className="timeline-item">
                      <div className="timeline-dot"></div>
                      <div className="timeline-header">
                        <h3 className="timeline-title">{project.title}</h3>
                        {project.date && <span className="timeline-date">{project.date}</span>}
                      </div>
                      <p className="timeline-company">{project.language}</p>
                      <p className="timeline-description">{project.description}</p>
                      <a href={project.linkgithub} className="project-link" target="_blank" rel="noopener noreferrer">
                        View Project →
                      </a>
                    </div>
                  ))}
                </div>
              </div>

              {/* Achievements */}
              <div className="content-section">
                <h2 className="section-title">
                  <span className="section-icon">🏆</span>
                  <span>Achievements & Certifications</span>
                </h2>
                <div className="timeline">
                  {achdata.map((ach) => (
                    <div key={ach.id} className="timeline-item">
                      <div className="timeline-dot"></div>
                      <div className="timeline-header">
                        <h3 className="timeline-title">{ach.position}</h3>
                        <span className="timeline-date">{ach.date}</span>
                      </div>
                      <p className="timeline-company">@ {ach.company}</p>
                      <p className="timeline-description">{ach.about}</p>
                      <div className="timeline-tags">
                        {ach.skills.split(',').map((skill, idx) => (
                          <span key={idx} className="tag">{skill.trim()}</span>
                        ))}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Print;